import { useFetchPaginatedData } from "@hooks/api/useFetchPaginatedData";
import { GetAllFormularios } from "@services/Formulario/Index";

export function useFetchDataFormulariosModelos() {
    // Usa o hook genérico para buscar todos os formulários com o filtro de apenas modelos
    const { data, loading, fetchAllData } = useFetchPaginatedData(GetAllFormularios, 50, { flgModelo: true });

    return {
        formulariosModelosOptions: data.map((item) => ({
            value: item.id,
            label: item.titulo,
        })).sort((a, b) => a.label.localeCompare(b.label)),
        formulariosLoading: loading,
        fetchFormularios: fetchAllData,
    };
}
